import React, { createContext, type ReactNode } from "react";
import { ConfigurationsType } from "./configurationMenu";

const RouterContext = createContext<ReactNode>(() => <></>);
const ConfigurationContext = createContext<ConfigurationsType>([
	[],
	() => <></>,
]);
const NavbarContext = createContext<ReactNode>(() => <></>);

export { RouterContext, ConfigurationContext, NavbarContext };
